import { useIsCurrentPageType } from '@avensia/excite';
import { useCurrentPageIsCheckoutPage } from 'webapp/pages/checkout/use-current-page-is-checkout-page';

export function useIsCheckoutFlow() {
  const isCheckoutPage = useCurrentPageIsCheckoutPage();
  const isOrderConfirmationPage = useIsCurrentPageType<NordicNest.Api.OrderConfirmationPageApiModel>();
  return isCheckoutPage || isOrderConfirmationPage;
}
